export default class detailShow{
    constructor(kv,update,btn,resize,reset){

        this.kv = kv;
        this.detailUpdate = update;
        this.btn = btn;
        this.resize = resize;
        this.reset = reset;

    }

    /* ---------------------------------------------------

　　　-- 詳細セット

    --------------------------------------------------- */

    set(direction){

        // set
        if(!Useragnt.mobile && !Useragnt.tablet){

            this.kv.canvasSet();

            switch(direction) {
                case 'next':
                    TweenMax.set(this.kv.detailContent[this.kv.status.index].querySelectorAll('.fake-image')[0], {
                        x: '100%',
                        y: '120%',
                        rotation:-55,
                        transformOrigin: "50% 0%",
                    });
                    TweenMax.set(this.kv.detailContent[this.kv.status.index].querySelectorAll('.fake-image')[1], {
                        x: '100%',
                        y: '120%',
                        rotation:-35,
                        transformOrigin: "50% 0%",
                    });
                    TweenMax.set(this.kv.detailContent[this.kv.status.index].querySelector('.image'), {
                        x: '100%',
                        y: '120%',
                        rotation:-15,
                        transformOrigin: "50% 0%",
                    });
                    break;
                case 'prev':
                    TweenMax.set(this.kv.detailContent[this.kv.status.index].querySelectorAll('.fake-image')[0], {
                        x: '-100%',
                        y: '-120%',
                        rotation:-55,
                        transformOrigin: "50% 100%",
                    });
                    TweenMax.set(this.kv.detailContent[this.kv.status.index].querySelectorAll('.fake-image')[1], {
                        x: '-100%',
                        y: '-120%',
                        rotation:-35,
                        transformOrigin: "50% 100%",
                    });
                    TweenMax.set(this.kv.detailContent[this.kv.status.index].querySelector('.image'), {
                        x: '-100%',
                        y: '-120%',
                        rotation:-15,
                        transformOrigin: "50% 100%",
                    });
                    break;
            }
            TweenMax.set(this.kv.detailContent[this.kv.status.index].querySelectorAll('.fake-image')[0], {
                z:-75,
                scale:0.7,
                opacity:0,
                display:'none',
            });
            TweenMax.set(this.kv.detailContent[this.kv.status.index].querySelectorAll('.fake-image')[1], {
                z:-55,
                scale:0.7,
                opacity:0,
                display:'none',
            });
            TweenMax.set(this.kv.detailContent[this.kv.status.index].querySelector('.image'), {
                z:-45,
                scale:0.9,
                opacity:0,
                display:'none',
            });
            TweenMax.set(['#js__canvas-detail'+this.kv.status.index,'#p-kv__detail'+this.kv.status.index+' .bg'] , {
                z: -100,
                opacity: 0,
                x: '-50px'
            });
        }else{

            this.reset.set();

        }
        TweenMax.set([this.kv.detailNumber[this.kv.status.index].children,this.kv.detailEn[this.kv.status.index].children,this.kv.detailJp[this.kv.status.index].children], {
            y: '100%',
        });
        TweenMax.set([this.kv.detailText[this.kv.status.index]], {
            opacity: 0,
            y: '50px',
        });

    }

    /* ---------------------------------------------------

　　　-- 詳細表示

    --------------------------------------------------- */

    show(_type,direction){

        if (_type === 'detail') {
            TweenMax.to(this.kv.back, 0.6, {
                opacity: 0,
                display: 'none',
                scale: 0.8,
                ease: Sine.easeOut,
            });
        }

        this.kv.detailContent[this.kv.status.index].removeAttribute('style');
        TweenMax.set(this.kv.detailContent[this.kv.status.index], {
            display:'block',
            opacity:1,
            rotation: 0,
            z: 0,
            x: '0%',
            y: '0%',
            scale: 1,
            transformOrigin: "50% 0%",
        });

        if(!Useragnt.mobile && !Useragnt.tablet) {
            if (_type === 'detail') {
                TweenMax.to(document.getElementById('canvas'), .3, {
                    opacity: 0,
                });
            }
            TweenMax.staggerTo(this.kv.detailContent[this.kv.status.index].querySelectorAll('.fake-image'), .1, {
                display: 'block',
                opacity: 1,
            }, 0.2);
            switch(direction) {
                case 'next':
                    TweenMax.staggerTo(this.kv.detailContent[this.kv.status.index].querySelectorAll('.fake-image'), 2.2, {
                        delay: .1,
                        rotation: 0,
                        z: 0,
                        x: '-100%',
                        y: '-120%',
                        scale: 0.85,
                        transformOrigin: "50% 0%",
                        ease: this.kv.easeBack,
                    }, 0.2);
                    break;
                case 'prev':
                    TweenMax.staggerTo(this.kv.detailContent[this.kv.status.index].querySelectorAll('.fake-image'), 2.2, {
                        delay: .1,
                        rotation: 0,
                        z: 0,
                        x: '100%',
                        y: '120%',
                        scale: 0.85,
                        transformOrigin: "50% 100%",
                        ease: this.kv.easeBack,
                    }, 0.2);
                    break;
            }
            TweenMax.to(this.kv.detailContent[this.kv.status.index].querySelector('.image'), .1, {
                delay: .4,
                display: 'block',
                opacity: 1,
            });
            TweenMax.to(this.kv.detailContent[this.kv.status.index].querySelector('.image'), 1.4, {
                delay: .4,
                rotation: 0,
                z: 0,
                x: '0%',
                y: '0%',
                scale: 1,
                transformOrigin: "50% 0%",
                ease: this.kv.easeBack,
                onComplete: () => {
                    TweenMax.to('#js__canvas-detail' + this.kv.status.index, .4, {
                        z: 0,
                        opacity: 1,
                        x: '0px',
                        ease: this.kv.easeBack,
                        onStart: () => {
                            window.mv_main.stopRender();
                            this.comp(_type);
                        },
                        onComplete: () => {
                            this.kv.status.animation = false;
                            TweenMax.to(this.kv.close, 0.4, {
                                display: 'block',
                                opacity: 1,
                                scale: 1,
                                transformOrigin: "100% 0%",
                                ease: this.kv.easeBack
                            });
                            if(_type === 'detail'){
                                TweenMax.fromTo([this.kv.pager],0.6, {
                                    display: 'none',
                                    opacity: 0,
                                    scale: 0.8,
                                },{
                                    display: 'block',
                                    opacity: 1,
                                    scale: 1,
                                    ease: this.kv.easeBack,
                                });
                                TweenMax.fromTo([this.kv.headerTitle],0.6, {
                                    display: 'none',
                                    opacity: 0,
                                    scale: 0.8,
                                },{
                                    display: 'block',
                                    opacity: 1,
                                    scale: 1,
                                    ease: this.kv.easeBack,
                                });
                            }
                        }
                    });
                }
            });
        }else{
            TweenMax.to(this.kv.pager, .6 , {
                scale: 0.8,
                opacity: 0,
                ease: this.kv.easeBack,
            });
            this.comp(_type);
            TweenMax.to(this.kv.close, 0.4, {
                delay:0.4,
                display: 'block',
                opacity: 1,
                scale: 1,
                transformOrigin: "100% 0%",
                ease: this.kv.easeBack,
            });
        }

    }

    /* ---------------------------------------------------

     -- テキストの表示

    --------------------------------------------------- */

    text(){

        TweenMax.set(this.kv.detailContent[this.kv.status.index], {
            delay:0.2,
            display:'block',
            onComplete:() => {
                TweenMax.staggerTo(this.kv.detailNumber[this.kv.status.index].children, .6 ,{
                    y:'0%',
                    ease: this.kv.easeBack,
                },0.05);
                TweenMax.to([this.kv.detailEn[this.kv.status.index].children,this.kv.detailJp[this.kv.status.index].children,this.kv.detailText[this.kv.status.index]], .5 ,{
                    opacity:1,
                    y:'0%',
                    ease: Sine.easeOut,
                });
            }
        });

    }

    /* ---------------------------------------------------

     -- アニメーション終わった後の処理

    --------------------------------------------------- */

    comp(type){

        this.text();
        if(type === 'change'){
            this.detailUpdate.set();
        }
        this.btn.show();
        let _w = window.innerWidth;
        let _h = window.innerHeight;
        this.resize.set(_w,_h);
        this.kv.status.animation = false;
        this.kv.canvasStart();

    }

}